var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBmi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.998 45.724H24.2615C23.6261 45.724 23.1116 46.2385 23.1116 46.8739V63.5437C23.1116 64.1791 23.6261 64.6936 24.2615 64.6936H34.998C35.6333 64.6936 36.1471 64.1791 36.1471 63.5437V46.8731C36.1471 46.2377 35.6326 45.724 34.998 45.724ZM51.7385 11.3074H41.002C40.3666 11.3074 39.8521 11.8219 39.8521 12.4573V63.5429C39.8521 64.1783 40.3666 64.6928 41.002 64.6928H51.7385C52.3739 64.6928 52.8884 64.1783 52.8884 63.5429V12.4573C52.8884 11.8219 52.3739 11.3074 51.7385 11.3074ZM68.5649 26.8273H57.8284C57.193 26.8273 56.6785 27.3419 56.6785 27.9772V63.5429C56.6785 64.1783 57.193 64.6928 57.8284 64.6928H68.5641C69.1995 64.6928 69.714 64.1783 69.714 63.5429V27.9772C69.714 27.3426 69.1995 26.8273 68.5649 26.8273ZM18.1716 26.8273H7.43507C6.79971 26.8273 6.28519 27.3419 6.28519 27.9772V63.5429C6.28519 64.1783 6.79971 64.6928 7.43507 64.6928H18.1716C18.8069 64.6928 19.3215 64.1783 19.3215 63.5429V27.9772C19.3215 27.3426 18.8069 26.8273 18.1716 26.8273Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmi);
export default __webpack_public_path__ + "static/media/bmi.2bbb489fba427c84eadccb6e06eea842.svg";
export { ForwardRef as ReactComponent };